/**
 * Agent tools that were deleted from the agents backend because their findings were
 * fabricated (hardcoded release rows and canned scan findings). Invoking one now
 * returns `tool_not_available:<name>`, so an agent that still lists it must show the
 * tool as retired rather than advertising an action that cannot run.
 *
 * NOTE: these names are retired for AGENTS ONLY. The Release Scanner product under
 * /release-scanner talks to the playground backend, where the same three tools are
 * still implemented and fully supported — do not disable that surface.
 */
const RETIRED_AGENT_TOOLS = new Set(["list_releases", "load_release_rules", "run_release_scan"]);

export function isRetiredAgentTool(tool: string): boolean {
  return RETIRED_AGENT_TOOLS.has(tool);
}

/** Tools an agent can actually run — the set its plan should be judged against. */
export function activeAgentTools(tools: string[]): string[] {
  return tools.filter((tool) => !isRetiredAgentTool(tool));
}

export const RETIRED_AGENT_TOOL_REASON =
  "Retired — this tool reported findings it could not substantiate and no longer runs.";
